import { apiGet, apiPost } from "./client";

export interface CartItem {
  show_id: number;
  event_title: string;
  num_performances: number;
  max_ticket_price: number;
  line_total_cents: number;
  is_first_premium: boolean;
  track: number | null;
}

export interface CartSummary {
  items: CartItem[];
  total_cents: number;
  currency: string;
}

export const premiumApi = {
  getStatus(showId: number): Promise<{ is_premium: boolean }> {
    return apiGet(`/api/premium/status/${showId}`);
  },

  getCart(): Promise<CartSummary> {
    return apiGet("/api/premium/cart");
  },

  checkout(showIds: number[]): Promise<{ sessionId: string; url: string }> {
    return apiPost("/api/premium/checkout", { show_ids: showIds });
  },
};
